import { combineReducers } from 'redux';

import Assets from './assets';
import Auth from './auth';
import Common from './common';
import Collections from './collections';
import Favorites from './favorites';
import Metadata from './metadata';
import Notifications from './notifications';
import Npvr from './npvr';
import Parental from './parental';
import Purchase from './purchase';
import Schedule from './schedule';
import Showcase from './showcase';
import Vlive from './vlive';

const rootReducer = combineReducers({
  assets: Assets,
  auth: Auth,
  collections: Collections,
  common: Common,
  favorites: Favorites,
  metadata: Metadata,
  notifications: Notifications,
  npvr: Npvr,
  parental: Parental,
  purchases: Purchase,
  schedule: Schedule,
  showcase: Showcase,
  vlive: Vlive
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js